import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import { pillClass, PILL_STYLE } from './LabelBadge';

// A gradient fill no label can have (labels are one solid colour the user
// picks), so the strategy badge reads as its own kind of thing. The fill never
// changes — the colour is how the badge is recognised — so a fit due for review
// adds an amber ring plus a refresh icon instead, and the hover says why. The
// ring is a box-shadow so it doesn't change the pill's height.
const FILL = { backgroundImage: 'linear-gradient(90deg, #6d28d9, #c026d3)', color: '#ffffff' };
const DUE_RING = { boxShadow: '0 0 0 2px #f59e0b' };

/**
 * StrategyBadge (issue #411) - the strategy watching this stock, from
 * `strategyBadgeFor` (src/utils/strategyBadge.js). The hover text rides the
 * `strategy-tooltip` react-tooltip (CompanyRowTooltips, mounted once by StockTable).
 */
const StrategyBadge = ({ badge }) => {
  if (!badge) return null;
  return (
    <span
      className={pillClass('sm')}
      style={{ ...PILL_STYLE, ...FILL, ...(badge.due ? DUE_RING : null) }}
      data-tooltip-id="strategy-tooltip"
      data-tooltip-content={badge.tip}
      aria-label={badge.tip}
    >
      {badge.name}
      {badge.due && <FiRefreshCw aria-hidden style={{ fontSize: '0.95em', strokeWidth: 2.5 }} />}
    </span>
  );
};

export default StrategyBadge;
